<template>
    <div>
        <el-dialog
            :visible.sync="showModal"
            width="800px"
            append-to-body
            :close-on-click-modal="false"
            @closed="resetForm"
            :destroy-on-close="true"
        >
            <template slot="title">
                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                    <el-tag class="rounded-circle" type="warning"><i class="el-icon-office-building"></i></el-tag>
                    Editar prazo de pagamento
                </div>
            </template>

            <el-form 
                :model="payload"
                ref="prazoPagamentoEditForm"
                label-position="top"
                status-icon
            > 
                <el-row :gutter="12">
                    <!-- Codigo -->
                    <el-col :span="6">
                        <el-form-item
                            prop="codigo_protheus"
                            :rules="[
                                { required: true, message: 'O código do protheus é obrigatório' },
                            ]"
                        >
                            <label>Código Protheus</label>

                            <el-input-number
                                v-model="payload.codigo_protheus"
                                placeholder="Ex: 2"
                                :max="10000"
                                :controls="false"
                                :disabled="isLoading"
                            >
                            </el-input-number>
                        </el-form-item>
                    </el-col>

                    <!-- Descricao -->
                    <el-col :span="18">
                        <el-form-item 
                            prop="descricao"
                            :rules="[
                                { required: true, message: 'A descrição é obrigatória' },
                            ]"
                        >
                            <label>Descrição</label>
                            <el-input
                                v-model="payload.descricao" 
                                placeholder="Ex: Matriz"
                                :disabled="isLoading"
                            />
                        </el-form-item>
                    </el-col>
                
                    <!-- Actions -->
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-form-item>
                                <el-button 
                                    plain
                                    :disabled="isLoading"
                                    @click="() => {
                                        toggleModal();
                                        resetForm();
                                    }"
                                >
                                    Cancelar
                                </el-button>

                                <el-button 
                                    type="primary"
                                    plain
                                    :disabled="isLoading"
                                    @click="onSubmit"
                                >
                                    <i v-if="isLoading" class="el-icon-loading"></i>
                                    <i class="fas fa-check-circle"></i>
                                    Salvar
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    // Components
    import {
        Loading,
        Row,
        Col,
        Button,
        Input,
        Notification,
        Form,
        FormItem,
        Tag,
        Avatar,
        InputNumber,
    } from "element-ui";

    //Api
    import { PrazoPagamentoApi } from "@/api/PrazoPagamentoApi";
    import { GeneralResourcesApi } from "@/api/GeneralResourcesApi";

    const generalResourcesApi = new GeneralResourcesApi();
    const prazoPagamentoApi = new PrazoPagamentoApi();

    export default {
        name: 'prazo-pagamento-edit',
        data() {
            return {
                prazoPagamentoId: null,
                payload: {
                    codigo_protheus: null,
                    descricao: null,
                },
                showModal: false,
                isLoading: false,
                prazoPagamento: null,
            }
        }, 
        methods: {
            async show() {
                try {
                    this.isLoading = true;

                    const res = await prazoPagamentoApi.show(this.prazoPagamentoId);

                    this.prazoPagamento = res;
                } catch (error) { 
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter o prazo de pagamento. Algo inesperado ocorreu!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            async onSubmit() {
                this.$refs.prazoPagamentoEditForm.validate( async (valid) => {
                    if (!valid) {
                        return false
                    } 

                    this.isLoading = true;
                    
                    try {
                        await prazoPagamentoApi.update(this.payload, this.prazoPagamentoId)

                        Notification.success({
                            title: 'Sucesso',
                            message: 'Prazo de pagamento atualizado!'
                        });
                    } catch (error) {
                        if (error?.response?.status == 422) {
                            if (error?.response?.data.errors) {
                                Object.values(error.response.data.errors)
                                .flat()
                                .forEach(err_message => {
                                    Notification.warning({
                                        title: 'Atenção',
                                        message: err_message
                                    });
                                });
                            }
                            return
                        }

                        Notification.error({
                            title: 'Erro',
                            message: 'Não foi possível atualizar o prazo de pagamento!'
                        });
                    } finally {
                        this.isLoading = false;
                        this.toggleModal();
                        this.resetForm();
                        this.$emit('updated');
                    }
                })
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetForm() {
                if (this.$refs.prazoPagamentoStoreForm) {
                    this.$refs.prazoPagamentoStoreForm.resetFields();
                }
            },
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole']([
                    'adm',
                    'coord_comercial',
                    'gerente_regional'
                ]);
            },
        },
        watch: {
            "prazoPagamento": {
                 handler(_newValue) {
                    this.payload = {
                        codigo_protheus: _newValue?.codigo_protheus,
                        descricao: _newValue?.descricao,
                    }
                }
            },
        },
        components: {
            [Loading.name]: Loading,
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Input.name]: Input,
            [Button.name]: Button,
            [Tag.name]: Tag,
            [Avatar.name]: Avatar,
            [InputNumber.name]: InputNumber,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_macro/prazo_pagamento/PrazoPagamentoEdit.vue